import React, { Component } from "react";
import { Modal, Form } from "react-bootstrap";
import { EthinicityOptions, ItentificationTypeOptions, RelationShipOptions, SOCIAL_SECURITY_NUMBER_FORMAT, genderOptions, isDotDriver, raceOptions } from "../../../utils/constant";
import FormInputs from "../../../components/UI/FormInputs";
import EmployeeService from "../../../services/EmployeeService";
import FileManagerService from "../../../services/FileManagerService";
import { formatPhoneNumberUS, isSet, locations } from "../../../utils/commonUtils";
import WithRoutify from "../../../hoc/WithRoutify";
import InsuranceService from "../../../services/InsuranceService";
import ClinicService from "../../../services/ClinicService";
import CompanyService from "../../../services/CompanyService";
import DivisionService from "../../../services/DivisionService";
import ClinicDepartmentService from "../../../services/ClinicDepartmentService";
import DropDownService from "../../../services/DropDownService";
import Buttons from "../../../components/UI/Buttons";

// Canadian province codes to filter out (only show US states)
const canadianProvinces = ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];

// State options (US states only) - both label and value are state abbreviations
// Generated from locations object, excluding Canadian provinces
const stateOptions = [
  { label: "-Select State-", value: "" },
  ...Object.keys(locations)
    .filter(key => !canadianProvinces.includes(key))
    .map(key => ({
      label: key,
      value: key
    }))
];

class PatientDetails extends Component{
    constructor(props){
        super(props);
        this.state = {
            insuranceListOptions:[],
            clinicLocationListOptions:[],
            fetchCompaniesListOptions:[],
            clinicListOptions:[],
            divisionListOption:[],
            division2ListOption:[],
            showDemographyEmailModal: false,
            demographyEmail: '',
        }
    }
    componentDidMount = ()=>{
        const {formData} = this.props;
        const clinicId =  formData.clinic_id;
        this.fetchEmployeeListOptions();
        if(isSet(formData.clinic_id,null)!==null){
            this.fetchClinicApis(clinicId);
            this.fetchDivisionList(formData.company_id);
            if(isSet(formData.division_id,null)!==null){
              this.fetchDivision2List(formData.division_id);
            }
        }
        try{
            if(isSet(formData.division_id,null)!==null){
              this.fetchDivision2List(formData.division_id);
            }
        }catch(e){

        }
        
        this.fetchInsuranceList();
        this.fetchCompaniesList();
        
    }
    componentDidUpdate =(prevProps)=>{
        const {formData} = this.props;
        if(  prevProps.formData.company_id!==this.props.formData.company_id){
            this.fetchClinicApis(this.props.formData.company_id);
        }
        try{
          if(prevProps.formData.division_id!==this.props.formData.division_id){
            if(isSet(formData.division_id,null)!==null){
              this.fetchDivision2List(formData.division_id);
            }
          }
          if(prevProps.formData.company_id!==this.props.formData.company_id){
            if(isSet(formData.company_id,null)!==null){
              this.fetchDivisionList(formData.company_id);
              this.fetchCompaniesList();
            }
          }
          if(prevProps.formData.clinic_id!==this.props.formData.clinic_id){
            if(isSet(formData.clinic_id,null)!==null){
              this.fetchClinicLocationList(formData.clinic_id);
            }
            else{
              this.setState({clinicLocationListOptions:[]});
            }
          }
        }catch(e){

        }
        
    }
    fetchClinicApis = async (company_id)=>{
        const [clinicLocationList, clincList] = await Promise.all([
            // this.fetchClinicLocationList(clinicId),
            this.fetchClinicDetails(company_id)
          ]);
          // this.props.onChangeHandler('clinic_name',isSet(clinicDetails,{clinic_name:''}).name);
          // this.setState({
          //   // clinicLocationListOptions:clinicLocationList,
          //   clinicListOptions:clincList
          // });
    }
     fetchClinicDetails = async (company_id)=>{
        try{
          let options=[{label:'-Select Clinic',value:''}];
          if (company_id) {
            const data = await DropDownService.getClinicDropDownListByCompany(null,{company_id:company_id});
            data.forEach(item => {
              options.push({label:item.name,value:item.clinic_id})
            });
          }
          this.setState({
            clinicListOptions:options
          });
          return options;
        }catch(e){
  
        }
      }
       fetchClinicLocationList = async (clinicId)=>{
        try{
          const data = await ClinicDepartmentService.getClinicDepartmentByClinicId(null,clinicId);
          let clinicLocationInArr = [{label:'-None-',value:''}];
          isSet(data,[]).forEach((item,itemIndex)=>{
            clinicLocationInArr.push({
              label:item.facility_name,
              value:item.id,
              key:itemIndex
            })
          });
          this.setState({clinicLocationListOptions:clinicLocationInArr});
          return clinicLocationInArr;
        }catch(e){
  
        }
      }
    render(){
        const {formData,onChangeHandler,validations} = this.props;
        const {clinicLocationListOptions,divisionListOption,division2ListOption,employeeListOptions} = this.state;
        console.log('clinicLocationListOptions',clinicLocationListOptions);
        
        const inputFields = [
          {
            label:'Company and Clinic Details',
            data:[
              {
                type: "SelectList",
                label: "Company",
                placeholder: "Company",
                className: "form-control form-control-solid",
                name: "company_id",
                // readOnly:true,
                options:this.state.fetchCompaniesListOptions,
                required:true,
              },
              {
                type: "SelectList",
                options:this.state.clinicListOptions,
                label: "Clinic",
                placeholder: "Clinic",
                className: "form-control form-control-solid",
                name: "clinic_id",
                // readOnly:true,
                required:true,
              },
              {
                type: "SelectList",
                label: "Clinic Department",
                placeholder: "Clinic Department",
                className: "form-control form-control-solid",
                name: "clinic_department_id",
                options:clinicLocationListOptions,
                // readOnly:isSet(formData.company_id,null)===null?true:false,
                // value:formData.clinic_location_id,
              },
              {
                type: "SelectList",
                label: "Division",
                placeholder: "Division",
                className: "form-control form-control-solid",
                name: "division_id",
                options:divisionListOption,
                // required:true,
              },{
                type: "SelectList",
                label: "Division 2",
                placeholder: "Division 2",
                className: "form-control form-control-solid",
                name: "division2_id",
                options:division2ListOption,
                // required:true,
              },
              {
                    type: "NonEdit",
                    label: "System Id",
                    placeholder: "",
                    className: "",
                    name: "system_id",
                  },
            ]
          },
            {
              label:'Personal',
              data:[
                {
                  type: "Checkbox",
                  label: "Is Dependent ?",
                  placeholder: "",
                  isLabelAppend:true,
                  className: "form-check-input",
                  id:'is_dependent',
                  name: "is_dependent",
                },
                {
                  type: "SelectList",
                  options:employeeListOptions,
                  label: "Patient/Employee",
                  placeholder: "Patient/Employee",
                  className: "form-control form-control-solid",
                  name: "dependent_id",
                  value: formData.dependent_id,
                  required: true,
                  isShow:formData.is_dependent==1,
                },
                {
                  type: "SelectList",
                  options:RelationShipOptions,
                  label: "Dependent Relationship",
                  placeholder: "Last Name",
                  className: "form-control form-control-solid",
                  name: "dependent_relationship",
                  value: formData.dependent_relationship,
                  isShow:formData.is_dependent==1,
                },
                {
                type: "TextInput",
                label: "First Name",
                placeholder: "First Name",
                className: "form-control form-control-solid",
                name: "first_name",
                required: true,
                isFirstLetterCaps:true,
              },
              {
                type: "TextInput",
                label: "Last Name",
                placeholder: "Last Name",
                className: "form-control form-control-solid",
                name: "last_name",
                required: true,
                isFirstLetterCaps:true,
              },
              {
                type: "SelectList",
                label: "Gender",
                placeholder: "Gender",
                options:genderOptions,
                className: "form-control form-control-solid",
                name: "gender",
                required:true
              },
              {
                type: "Date",
                label: "Date of Birth",
                placeholder: "Date of Birth",
                withAge:true,
                className: "form-control form-control-solid",
                name: "dob",
                disableFuture:true,
                required:true
              },
              {
                type: "Age",
                label: "Age",
                placeholder: "",
                readOnly:true,
                className: "form-control form-control-solid",
                isNotValidate:true,
                name: "dob",
              },
              {
                type: "Phone",
                label: "Social Security Number",
                placeholder: "Social Security Number",
                className: "form-control form-control-solid",
                name: "social_security_number",
                numberFormat:SOCIAL_SECURITY_NUMBER_FORMAT,
                maskChar:'x'
              },
              {
                type: "SelectList",
                label: "Ethnicity",
                placeholder: "Ethnicity",
                className: "form-control form-control-solid",
                name: "ethnicity",
                options:EthinicityOptions,
                // value:formData.ethnicity,
              },
              {
                type: "SelectSearchList",
                label: "Race",
                placeholder: "Race",
                options:raceOptions,
                className: "form-control form-control-solid",
                name: "race",
                isMulti: true,
                // value:formData.race,
              },
           
              ]
            },{
              label:'Address',
              data:[
              //   {
              //   type: "Address",
              //   label: "Full Address",
              //   placeholder: "Full Address",
              //   className: "form-control form-control-solid",
              //   name: "address",
              // },
              {
                type: "TextInput",
                label: "Street",
                placeholder: "street",
                className: "form-control form-control-solid",
                name: "street_address",
                required:true,
              },
              {
                type: "TextInput",
                label: "City",
                placeholder: "City",
                className: "form-control form-control-solid",
                name: "city",
                required:true,
              },
              {
                type: "TextInput",
                label: "State",
                placeholder: "State",
                className: "form-control form-control-solid",
                name: "state",
                required:true,
              },
              {
                type: "TextInput",
                label: "County",
                placeholder: "County",
                className: "form-control form-control-solid",
                name: "county",
              },
              {
                type: "ZipCode",
                label: "Zipcode",
                placeholder: "Zipcode",
                className: "form-control form-control-solid",
                name: "zip_code",
                required:true,
              },
            ]
            },{
              label:'Contact',
              data:[
             {
                type: "TextInput",
                label: "Email",
                placeholder: "Email",
                className: "form-control form-control-solid",
                name: "email",
              },
               {
                type: "Phone",
                label: "Cell Number",
                placeholder: "Cell Number",
                className: "form-control form-control-solid",
                name: "phone",
              },]
            },{
              label:'Identification',
              data:[               
                   {
                    type: "SelectList",
                    label: "Is Dot Driver?",
                    placeholder: "IS Dot Driver?",
                    className: "form-control form-control-solid",
                    name: "is_dot_driver",
                    value: formData.is_dot_driver,
                    // required:formData.is_online_portal==1?true:false,
                    options:isDotDriver,
                  },
                  {
                    type: "SelectList",
                    label: "Identification type",
                    placeholder: "Identification type",
                    className: "form-control form-control-solid",
                    name: "identification_type",
                    options:ItentificationTypeOptions,
                    required:true,
                    // value:formData.identification_type,
                  },
                  {
                    type: "TextInput",
                    label: "Identification number",
                    placeholder: "Identification number",
                    className: "form-control form-control-solid",
                    name: "identification_number",
                    required:true,
                    // value:formData.identification_number,
                  },
                  {
                    type: "SelectList",
                    label: "License Issuing State",
                    placeholder: "License Issuing State",
                    className: "form-control form-control-solid",
                    name: "license_issuing_state",
                    options: stateOptions,
                    // required: formData.identification_type === "Driver's License",
                    isShow: formData.identification_type === "Driver's License",
                  },
                  {
                  type: "FileUpload",
                  label: "ID Picture",
                  placeholder: "",
                  className: "form-control1 form-control-solid1",
                  name: "id_picture",
                  // required: true,
                },
                ]
            },{
              label:'Private Insurance',
              data:[
                {
                  type: "SelectList",
                  label: "Insurance Name",
                  placeholder: "Insurance Name",
                  className: "form-control form-control-solid",
                  name: "insurance_id",
                  options:this.state.insuranceListOptions,
                },
                {
                  type: "TextInput",
                  label: "Member Number",
                  placeholder: "Member Name",
                  className: "form-control form-control-solid",
                  name: "member_number",
                },
                {
                  type: "TextInput",
                  label: "Group Number",
                  placeholder: "Group Number",
                  className: "form-control form-control-solid",
                  name: "group_number",
                },
              
                {
                  type: "FileUpload",
                  label: "Insurance Card (Front)",
                  placeholder: "",
                  className: "form-control1 form-control-solid1",
                  name: "insurance_card_front",
                },
                {
                  type: "FileUpload",
                  label: "Insurance Card (Back)",
                  placeholder: "",
                  className: "form-control1 form-control-solid1",
                  name: "insurance_card_back",
                },
              ]
            },
              {
              label:'Employer',
              data:[
                 {
                type: "SelectList",
                label: "Company",
                placeholder: "Company",
                className: "form-control form-control-solid",
                name: "company_id",
                // readOnly:true,
                options:this.state.fetchCompaniesListOptions,
                required:true,
              },
              {
                type: "TextInput",
                label: "Job Title Description",
                placeholder: "Job Title Description",
                className: "form-control form-control-solid",
                name: "job_title_description",
                value: formData.job_title_description, 
              },
              {
                  type: "Date",
                  label:"Start Date",
                  name: "start_date",
                  className: "form-control form-control-solid",
                  value: formData.start_date,
                  placeholder: "Start Date",
                  required: false,
              },
              {
                  type: "TextInput",
                  label: "Employee Relationship",
                  placeholder: "Employee Relationship",
                  className: "form-control form-control-solid",
                  name: "employee_relationship",
                  value: formData.employee_relationship,
              },
              {
                  type: "TextInput",
                  label: "Reporting Supervisor",
                  placeholder: "Reporting Supervisor",
                  className: "form-control form-control-solid",
                  name: "reporting_supervisor",
                  isFirstLetterCaps:true,
                  value: formData.reporting_supervisor,
              },
              {
                  label:" Benefit Type",
                  type: "TextInput",
                  name: "benefit_type",
                  className: "form-control form-control-solid",
                  value: formData.benefit_type,
                  placeholder: "Benefit Type",
              },
                {
                  type: "TextInput",
                  label:"License/Certification Description",
                  name: "license_certification_description",
                  className: "form-control form-control-solid",
                  value: formData.license_certification_description,
                  placeholder: "License/Certification Description",
                },
                {
                  type:"Date",
                  label:"License Effective Date",
                  name: "license_effective_date",
                  className: "form-control form-control-solid",
                  value: formData.license_effective_date,
                  placeholder: "License Effective Date",  
                },
                {
                  type: "Date",
                  label:"License Expiration Date",
                  name: "license_expiration_date",
                  className: "form-control form-control-solid",
                  value: formData.license_expiration_date,
                  placeholder: "License Expiration Date",
                },
                {
                  type: "Checkbox",
                  label: "Disable Labs / Drug Screen Notification",
                  placeholder: "",
                  isLabelAppend:true,
                  className: "form-check-input",
                  id:'disable_labs_drugscreen_notification',
                  name: "disable_labs_drugscreen_notification",
                },
              ]},        
            {
                label:'Additional Information',
                data:[
                   {
                    type: "TextInput",
                    label: "Full Name of Guardian & Parents",
                    placeholder: "Full Name of Guardian & Parents",
                    className: "form-control form-control-solid",
                    name: "guardian_name",
                  },
                  {
                    type: "Phone",
                    label: "Guardian Cell Number",
                    placeholder: "Guardian Cell Number",
                    className: "form-control form-control-solid",
                    name: "guardian_phone",
                  },
                  {
                    type: "TextInput",
                    label: "Patient Id",
                    placeholder: "Patient Id",
                    className: "form-control form-control-solid",
                    name: "patient_id",
                  },
                  {
                    type: "TextInput",
                    label: "Booking Id",
                    placeholder: "Booking Id",
                    className: "form-control form-control-solid",
                    name: "booking_id",
                  },
                  {
                    type: "NonEdit",
                    label: "EMR Patient ID",
                    placeholder: "",
                    className: "",
                    name: "",
                  },
                    {
                    type: "NonEdit",
                    label: "System Id",
                    placeholder: "",
                    className: "",
                    name: "system_id",
                  },
                     {
                    type: "Checkbox",
                    label: "Active",
                    placeholder: "",
                    isLabelAppend:true,
                    className: "form-check-input",
                    id:'status',
                    name: "status",
                  },
                  // {
                  //   type: "TextInput",
                  //   label: "Driver's License",
                  //   placeholder: "Driver's License",
                  //   className: "form-control form-control-solid",
                  //   name: "driver_license",
                  //   // value:formData.identification_number,
                  // },
                // {
                //   type: "TextInput",
                //   label: "Pre-Registration Code",
                //   placeholder: "Pre-Registration Code",
                //   className: "form-control form-control-solid",
                //   name: "pre_registration_code",
                //   readOnly:true,
                // },
                ]
              },
          ];
        
        return(
            <>
            <div className="d-flex justify-content-end align-items-center gap-2 mb-2">
                <Buttons
                    className="btn btn-icon btn-light btn-sm rounded shadow-sm border"
                    iconType="Print"
                    title="Print Demography"
                    clickHandler={this.handlePrintDemography}
                />
                <Buttons
                    className="btn btn-icon btn-light btn-sm rounded shadow-sm border"
                    iconType="Email"
                    title="Email Demography"
                    clickHandler={() => this.setState({ showDemographyEmailModal: true, demographyEmail: this.props.formData?.email || '' })}
                />
            </div>
            {inputFields.map((section, secIndex) => {
                return (
                    <div className="card mb-2" key={secIndex}>
                        <a href={`#collapseCardExample_${secIndex}`} className="d-block sh_accordionheader card-header" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseCardExample" style={{ position: 'sticky', top: '-20px', zIndex: '1' }}>
                            <h6 className="mb-0 text-md">{section.label}</h6>
                        </a>
                        <div className="collapse show" id={`collapseCardExample_${secIndex}`} data-bs-parent="#modal111">
                            <div className="card-body">
                                <div className="row">
                                    {section.data.map((item, itemIndex) => {
                                      if (isSet(item.isShow, true) === false) { return false }
                                        const value = isSet(formData[item.name],'');
                                        return (
                                            <div className="col-sm-12" key={itemIndex}>
                                                <div className="form-group row">
                                                    <label className="col-sm-3 col-form-label opacity-75">{item.label}</label>
                                                    <div className="col-sm-9">
                                                      {isSet(item.isLabelAppend,false)===true?
                                                      <div className="form-check">
                                                        <FormInputs {...item} value={value} changeHandler={(val,e)=>{onChangeHandler(item.name,val,e);   if (item.name === 'company_id'){this.fetchCompanyDetails(val);}  }} />
                                                      </div>
                                                      :<>
                                                      <FormInputs {...item} value={value} changeHandler={(val,e)=>{onChangeHandler(item.name,val,e);   if (item.name === 'company_id'){this.fetchCompanyDetails(val);}  }} />
                                                      </> }

                                                      {isSet(item.isNotValidate) ? <></> : ((isSet(validations[item.name], '') !== '' && !value) ? <span className="text-danger m-1">{isSet(validations[item.name], '')}</span> : '')}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
            <Modal
                show={this.state.showDemographyEmailModal}
                onHide={() => this.setState({ showDemographyEmailModal: false })}
                dialogClassName="hResponsive"
                centered
                backdrop="static"
                keyboard={false}
            >
                <div className="sh_modalBox">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h6 className="text-lg mb-0 font-weight-bold" style={{ color: '#333' }}>Email Patient Demographics</h6>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group mb-3">
                            <Form.Label className="form-label" style={{ color: '#333', fontSize: '15px' }}>Email Id <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter email address"
                                value={this.state.demographyEmail}
                                onChange={(e) => this.setState({ demographyEmail: e.target.value })}
                                style={{ color: '#333', fontSize: '15px' }}
                                className="form-control form-control-solid"
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-center">
                        <button type="button" className="btn btn-secondary sh_btnsecondary mr-2" onClick={() => this.setState({ showDemographyEmailModal: false })}>Cancel</button>
                        <button type="button" className="btn btn-primary sh_btnprimary" onClick={this.handleSendDemographyEmail}>Send</button>
                    </Modal.Footer>
                </div>
            </Modal>
            </>
        )
    }
    handlePrintDemography = async () => {
        const { employeeId, Loader, Toast } = this.props;
        if (!employeeId) return;
        try {
            if (Loader) Loader(true);
            const base64Data = await EmployeeService.printEmployeesDemography([employeeId]);
            if (base64Data && typeof base64Data === 'string' && base64Data.length > 0) {
                const pdfData = {
                    file_content: base64Data,
                    original_name: 'PatientDemographics',
                    mime_type: 'application/pdf',
                };
                FileManagerService.printPdf(pdfData);
            } else if (Toast) {
                Toast.error('Failed to generate Patient Demographics PDF');
            }
        } catch (error) {
            console.error('Print demography error', error);
            if (this.props.Toast) this.props.Toast.error('Error printing Patient Demographics PDF');
        } finally {
            if (this.props.Loader) this.props.Loader(false);
        }
    };
    handleSendDemographyEmail = async () => {
        const { employeeId, Loader, Toast } = this.props;
        const { demographyEmail } = this.state;
        if (!employeeId || !demographyEmail || !demographyEmail.trim()) {
            if (Toast) Toast.error('Please enter a valid email address');
            return;
        }
        try {
            if (Loader) Loader(true);
            const result = await EmployeeService.sendPatientDemographyEmail(employeeId, demographyEmail.trim());
            this.setState({ showDemographyEmailModal: false, demographyEmail: '' });
            if (result && result.success) {
                if (Toast) Toast.success(result.success || 'Email sent successfully');
            } else if (result && result.error && Toast) {
                Toast.error(result.error);
            } else if (Toast) {
                Toast.error('Failed to send email');
            }
        } catch (error) {
            console.error('Send demography email error', error);
            if (Toast) Toast.error('Error sending Patient Demography email');
        } finally {
            if (Loader) Loader(false);
        }
    };
     fetchCompanyDetails = async (companyId)=>{
        try{
          const data = await CompanyService.getCompany(null,companyId);
            // this.props.onChangeHandler('clinic_id',data.clinic_id);
            // this.fetchClinicApis(data.clinic_id,companyId);
        }catch(e){
  
        }
      }
      fetchCompaniesList = async (query = '') => {
        // Assuming this.props.Loader(true); and this.props.Loader(false); are correctly managed elsewhere
        
        const companyId = this.props.company_id;
      
        try {
          let res = null;
          // Call CompanyService.getCompanies with await
        
          if(isSet(companyId)){
            res = await DropDownService.getCompanies(null)
          }else{
            const clinicId = this.props.clinic_id;
            query = {clinic_id : clinicId};
            res = await DropDownService.getCompanies(null)
            // console.log("response",res)
          }
        
           
          
          let companiesOptions = [{ label: '-None-', value: '' }];
          res.forEach((company) => {
            companiesOptions.push({
              label: company.name,
              value: company.company_uuid
            });
          });
      
          this.setState({
            fetchCompaniesListOptions: companiesOptions
          });
        } catch (err) {
          console.log("err===>", err);
        } finally {
          this.props.Loader(false);
        }
      };
      fetchDivisionList = async (companyId)=>{
        // const {Loader} = this.props;
        let options = [{label:'-Select-',value:''}]
        try{
            const res = await DivisionService.getDivisionByCompanyId(companyId);
            
            res.forEach((item)=>{
                options.push({
                    label:item.division_name,
                    value:item.division_id
                })
            });
            this.setState({divisionListOption:options});
        }catch(e){
        }
      }
      fetchDivision2List = async (divisionId)=>{
        // const {Loader} = this.props;
        let options = [{label:'-Select-',value:''}]
        try{
            const res = await DivisionService.getDivisionByParentId(divisionId);
           
            res.forEach((item)=>{
                options.push({
                    label:item.division_name,
                    value:item.division_id
                })
            });
            this.setState({division2ListOption:options});
        }catch(e){
        }
      }
    fetchInsuranceList = async ()=>{
        // const {Loader} = this.props;
        let options = [{label:'-Select-',value:''}]
        try{  
            const res = await InsuranceService.getInsurance();
            const resData = res.data;
            resData.data.data.forEach((item)=>{
                options.push({
                    label:item.insurance_name,
                    value:item.insurance_company_id
                })
            });
            this.setState({insuranceListOptions:options});
            // console.log('InsuranceList',data);
        }catch(e){
        }
    }
    fetchEmployeeListOptions=async()=>{
      const response =await DropDownService.getEmployeeList(null);
      let options=[{label:'-Select-',value:''}]
      response&&response?.forEach((itm,index)=>{
        if (itm.employee_id!=this.props.employeeId) {
          options.push({label:`${itm.first_name} ${itm.last_name} - ${formatPhoneNumberUS(itm.phone)}`,value:itm.employee_id}); 
        }
      });
      this.setState({employeeListOptions:options});   
    }
}


export default WithRoutify(PatientDetails);